import api from "@/lib/axios";

export const campaignsService = {
  // Get all campaigns from listing API
  getAllCampaigns: async (params = {}) => {
    try {
      const { data } = await api.get("/campaigns", { params });
      return data;
    } catch (error) {
      throw new Error("Failed to fetch campaigns: " + error.message);
    }
  },

  //get campaign by by company id
  getCampaignByCompanyId: async (companyId, params={}) => {
    try {

      const { data } = await api.get(`/company/${companyId}/campaigns`, { params });
      return data;
    } catch (error) {
      throw new Error("Failed to fetch campaigns: " + error.message);
    }
  },
  //get compaigns data  
  getCampaignBySlug: async (companySlug, campaignSlug) => {
    try {
      const { data } = await api.get(`/${companySlug}/${campaignSlug}`);
      return data?.data ?? data;

    } catch (error) {
      console.log("error messagge", error)
      if (error.response) {
        const apiError = error.response.data;
        const message = apiError.message || 'Validation error occurred';
        // Extract specific field errors (e.g., email)
        const fieldErrors = apiError.errors || {};
        // const emailError = fieldErrors.email ? fieldErrors.email[0] : null;
        throw new Error("Failed tfetch campaign: " + message);
      } else {

        throw new Error("Failed tfetch campaign: " + error.message);
      }
    }
  },
  // create campaign
  createCampaign: async (campaign) => {
    try {
      const response = await api.post("/campaigns", campaign, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.log("error messagge", error)
      if (error.response) {
        const apiError = error.response.data;
        const message = apiError.message || 'Validation error occurred';

        // Extract specific field errors (e.g., email)
        const fieldErrors = apiError.errors || {};
        // const emailError = fieldErrors.email ? fieldErrors.email[0] : null;

        console.log('General Message:', message);
        throw new Error("Failed to create campaign: " + message);
      } else {
        console.log('An unexpected error occurred:', error.message);
        throw new Error("Failed to create campaign: " + error.message);
      }
    }
  },

  // New update campaign service
  updateCampaign: async (campaignId, campaign) => {
    try {
      const response = await api.put(`/campaigns/${campaignId}`, campaign, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.log("error messagge", error)
      if (error.response) {
        const apiError = error.response.data;
        const message = apiError.message || 'Validation error occurred';

        // Extract specific field errors (e.g., email)
        const fieldErrors = apiError.errors || {};
        // const emailError = fieldErrors.email ? fieldErrors.email[0] : null;

        console.log('General Message:', message);
        throw new Error("Failed to update campaign: " + message);
        if (emailError) {
          console.log('Email Error:', emailError);
        }
      } else {
        console.log('An unexpected error occurred:', error.message);
        throw new Error("Failed to update campaign: " + error.message);
      }
    }
  },

  // Add this to the campaignsService object
  getCampaign: async (campaignId) => {
    try {
      const response = await api.get(`/campaigns/${campaignId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateCampaignStatus: async (campaignId, payload) => {
    try {
      const response = await api.post(`/campaign/status/${campaignId}`,
        payload, // Send the complete payload
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const apiError = error.response.data;
        const message = apiError.message || 'Failed to update campaign status';
        throw new Error(message);
      } else {
        throw new Error("Failed to update campaign status: " + error.message);
      }
    }
  },
  // Get all campaigns
  getCampaignsList: async (company_id, params = {}) => {
    try {
      const { data } = await api.get("/campaign/listing", { company_id, ...params });
      return data;
    } catch (error) {
      throw new Error("Failed to fetch campaigns: " + error.message);
    }
  },
};

